<template>
  <div class="tasks text-dark">
    <div class="tasks-header">
      <DFilters :filters="filters" @set="setFilter" :initialFilter="theFilter" style="margin: 0.5rem 0 -2px 0"></DFilters>
      <div class="tasks-header__right">
        <div class="do-spinner" v-if="isSubmittingTask"></div>
      <button class="do-bttn do-bttn--submit" style="width: 150px;height: 38px;"
              @click="setCreateNewTask">
        {{ i18n[locale]['create_tasks'] }}
      </button>
      </div>
    </div>
    <table class="d-table">
      <thead>
      <tr>
        <th style="width: 250px">
          <div class="d-search__hidden__group"
               :class="{'isShow': isSearchHiddenFadeIn}"
               @click="setIsSearchHidden(false)"
               v-on-clickaway="closeSearchGroup">
            <span class="icon-search5"></span>
            <div class="d-search__hidden__group--hide"
                 v-if="isSearchHidden">{{ i18n[locale]['search_task'] }}
            </div>
            <div class="d-search__hidden__group--show"
                 v-else>
              <input type="search"
                     ref="query_input"
                     v-model="query"
                     :placeholder="i18n[locale]['search_task']">
            </div>
          </div>
        </th>
        <th class="d-table__number" style="width: 80px">{{ i18n[locale]['teaching'] }}</th>
        <th class="d-table__number" style="width: 80px">{{ i18n[locale]['other_short'] }}</th>
        <th class="d-table__number" style="width: 80px">{{ i18n[locale]['prep'] }}</th>
        <th class="d-table__number" style="width: 80px" v-if="isSchoolFeatureLocalePool">{{ i18n[locale]['pool'] }}</th>
        <th style="width: 500px"><span class="icon-user3"></span> {{ i18n[locale]['teacher'] }}</th>
        <th style="width: 100px" class="d-table__number">{{ i18n[locale]['sum'] }} : {{ calcAllHours }}</th>
      </tr>
      </thead>
      <tbody>
      <div class="tr-create-shortcut"
           @click="setIsShowCreateFast"
           :class="{'tr-create-shortcut--active': isShowCreateFast}"
           :content="'<p class=' + 'tooltip-shortcut' + '>' + $t('vue2.common.press') + '<span>' + keyboardShortcut + '</span></p>'"
           v-tippy="{
                    arrow: true,
                    placement : 'bottom'
                  }">
        <span class="icon-cross2"></span>
      </div>
      <transition name="scaleIn">
        <tr class="create-task-fast" v-if="isShowCreateFast">
          <td>
            <input type="text" v-model="fastFormName" @keyup="removeErrors('fastFormName')"
                   :placeholder="i18n[locale]['task_name']" ref="shortcutInput"
                   :class="{'input--error': formErrors['fastFormName']}">
          </td>
          <td><input type="number"
                     :class="{'input--error': formErrors['fastFormHours']}"
                     v-model="fastFormHoursTeaching"
                     @keyup="removeErrors('fastFormHours')"
                     @focus="selectAllOnFocus($event)"
                     :disabled="(fastFormHoursPrep !== '' || fastFormHoursTask !== '') || (theFilter === 'additional_tasks' || theFilter === 'preparation')">
          </td>
          <td><input type="number"
                     :class="{'input--error': formErrors['fastFormHours']}"
                     v-model="fastFormHoursTask"
                     @keyup="removeErrors('fastFormHours')"
                     @focus="selectAllOnFocus($event)"
                     :disabled="(fastFormHoursPrep !== '' || fastFormHoursTeaching !== '') || (theFilter === 'person_resource' || theFilter === 'preparation' || theFilter === 'subject')">
          </td>
          <td><input type="number"
                     :class="{'input--error': formErrors['fastFormHours']}"
                     v-model="fastFormHoursPrep"
                     @keyup="removeErrors('fastFormHours')"
                     @focus="selectAllOnFocus($event)"
                     :disabled="(fastFormHoursTask !== '' || fastFormHoursTeaching !== '')  || (theFilter === 'additional_tasks' || theFilter === 'person_resource')">
          </td>
          <td v-if="isSchoolFeatureLocalePool">
            <input type="number"
                   :class="{'input--error': formErrors['fastFormHours']}"
                   v-model="fastFormHoursPool"
                   @keyup="removeErrors('fastFormHours')"
                   @focus="selectAllOnFocus($event)"
                   :disabled="(fastFormHoursTask !== '' || fastFormHoursTeaching !== '')  || (theFilter === 'additional_tasks' || theFilter === 'person_resource')">
          </td>
          <td>
            <div>
              <DSelectCalendarIds :show="activeDSelectShow"
                                  itemType="USER"
                                  :showTags="true"
                                  :preSelectedItems="fastFormUsers"
                                  @update="setSelectedUsers($event, null)">
              </DSelectCalendarIds>
            </div>
          </td>
          <td>
            <button class="bttn bttn--primary"
                    :class="{'bttn--primary--disabled': !isFastFormValid}"
                    style="width: 100px"
                    @click="submitFastForm">
              {{ i18n[locale]['create'] }}
            </button>
          </td>
        </tr>
      </transition>
      <tr v-for="task in searchedTasks" :key="task.id">
        <td>
          <div class="task__name">
            <div @click="setEditTask(task)"
                 :class="[{'td-subject--hidden': !task.can_schedule}, {'td-subject': task.can_schedule}]"
                 :style="{'background-color': task.color}">{{ task.name }}
            </div>
          </div>
        </td>
        <td class="d-table__number">{{ task.timeTeaching }}</td>
        <td class="d-table__number">{{ task.timeTasks }}</td>
        <td class="d-table__number">{{ task.timePrep }}</td>
        <td class="d-table__number" v-if="isSchoolFeatureLocalePool">{{ task.timePool }}</td>
        <td @click="setActiveDSelect(task)"
            :class="{'d-select-lookalike': !isActiveDSelect(task.id) && task.user_calendar_ids.length < 1}"
            :aria-placeholder-label="i18n[locale]['search_and_select']">
          <DSelectCalendarIds v-if="isActiveDSelect(task.id)"
                              :show="activeDSelectShow"
                              v-on-clickaway="closeDSelect"
                              itemType="USER"
                              :preSelectedItems="task.user_calendar_ids"
                              :itemsThatCantBeDeleted="usersWithEvents(task)"
                              :showTags="true"
                              :content=" getUserNames(usersWithEvents(task)) + ' ' + i18n[locale]['has_scheduled_and_cant_be_deleted']"
                              v-tippy="{
                                onShow: () => usersWithEvents(task).length > 0,
                                arrow: true,
                                placement : 'bottom'
                              }"
                              @update="setSelectedUsers($event, task)">
          </DSelectCalendarIds>
          <div class="task__users"
               v-if="!isActiveDSelect(task.id) && task.user_calendar_ids.length > 0">
            <p v-for="user in getUsers(task.user_calendar_ids)">{{ user }}</p>
          </div>
        </td>
        <td class="d-table__number">{{ getCalcTotal(task) }}</td>
      </tr>
      </tbody>
    </table>
    <div v-if="tasks.length < 1" class="explainer-div">{{ i18n[locale]['no_tasks_created'] }}</div>
    <div v-if="tasks.length > 0 && filteredTasks.length < 1" class="explainer-div">{{
        i18n[locale]['no_tasks_matching']
      }}
    </div>
    <CreateTask
      v-if="isTaskModal"
      :editTask="editTask"
      :activeFilter="theFilter"
      @close="closeUpdateTask"
      @create="createTask"
      @updateTask="updateTask">
    </CreateTask>
  </div>
</template>

<script>
import DSelectCalendarIds from '../DSelect/DSelectCalsIds'
import {mixin as clickaway} from 'vue-clickaway'
import CreateTask from './SubjectsDistributionTasksCreate'
import DFilters from '../common/DFilters'

const I18N = {
  da: {
    create_tasks: 'Opret opgaver',
    search_task: 'Søg på opgave',
    teaching_short: 'UV',
    other_short: 'Øvrig',
    prep: 'Forb.',
    teacher: 'Underviser',
    sum: 'Total',
    task_name: 'Opgavens navn...',
    create: 'Opret',
    search_and_select: 'Søg og vælg',
    has_scheduled_and_cant_be_deleted: 'har skemalagte brikker, og kan ikke fjernes',
    no_tasks_created: 'Der er ikke oprettet nogen opgaver',
    no_tasks_matching: 'Ingen opgaver matcher søgningen',
    all: 'Alle',
    teaching: 'Undervisning',
    additional_tasks: 'Øvrige opgaver',
    preparation: 'Forberedelse',
    pool: 'Lokalpulje'
  },
  nb: {
    create_tasks: 'Opprett oppgaver',
    search_task: 'Søk etter oppgave',
    teaching_short: 'undervisning',
    other_short: 'Oppgave',
    prep: 'Forberedelse',
    teacher: 'Underviser',
    sum: 'Totalt',
    task_name: 'Oppgavens navn...',
    create: 'Opprett',
    search_and_select: 'Søk og velg',
    has_scheduled_and_cant_be_deleted: 'er planlagt i timeplanen, og kan derfor ikke slettes.',
    no_tasks_created: 'Der er ikke opprettet noen oppgaver.',
    no_tasks_matching: 'Ingen treff',
    all: 'Alle',
    teaching: 'Undervisning',
    additional_tasks: 'Øvrige oppgaver',
    preparation: 'Forberedelse',
    pool: 'Planleggingsdager'
  },
  en: {
    create_tasks: 'Create tasks',
    search_task: 'Search for task',
    teaching_short: 'teaching',
    other_short: 'Additional',
    prep: 'Preparation',
    teacher: 'Teacher',
    sum: 'Total',
    task_name: 'Name of task...',
    create: 'Create',
    search_and_select: 'Search and choose',
    has_scheduled_and_cant_be_deleted: 'has been schedules, and cannot be deleted',
    no_tasks_created: 'No tasks created',
    no_tasks_matching: 'No match',
    all: 'All',
    teaching: 'Teaching',
    additional_tasks: 'Additional tasks',
    preparation: 'Preparation',
    pool: 'Custom pool'
  }
}

export default {
  components: {DFilters, DSelectCalendarIds, CreateTask},
  mixins: [clickaway],
  data () {
    return {
      isTaskModal: false,
      editTask: null,
      isSearchHidden: true,
      isSearchHiddenFadeIn: false,
      query: '',
      activeDSelect: null,
      activeDSelectShow: false,
      theFilter: '',
      isShowCreateFast: false,
      fastFormName: '',
      fastFormHoursTeaching: '',
      fastFormHoursTask: '',
      fastFormHoursPrep: '',
      fastFormUsers: [],
      formErrors: {}
    }
  },
  computed: {
    isSubmittingTask () {
      return this.$store.state.subjects.isSubmittingTask
    },
    i18n () {
      return I18N
    },
    locale () {
      return this.$store.getters.locale
    },
    isSchoolFeatureLocalePool () {
      return this.$store.getters.isSchoolFeatureLocalePool
    },
    activeSchoolYear () {
      return this.$store.state.localActivatedSchoolYear
    },
    tasks () {
      return this.$store.state.subjects.tasks
    },
    tasksTeaching () {
      return this.tasks.filter(task => task.subject_type === 'person_resource_visible' || task.subject_type === 'person_resource' || task.subject_type === 'subject')
    },
    tasksTasks () {
      return this.tasks.filter(task => task.subject_type === 'additional_tasks')
    },
    tasksPrep () {
      return this.tasks.filter(task => task.subject_type === 'preparation')
    },
    tasksPool () {
      return this.tasks.filter(task => task.subject_type === 'pool')
    },
    filters () {
      const filters = [
        {label: this.i18n[this.locale]['all'], value: '', length: this.tasks.length},
        {label: this.i18n[this.locale]['teaching'], value: 'person_resource', length: this.tasksTeaching.length},
        {label: this.i18n[this.locale]['additional_tasks'], value: 'additional_tasks', length: this.tasksTasks.length},
        {label: this.i18n[this.locale]['preparation'], value: 'preparation', length: this.tasksPrep.length},
        {label: this.i18n[this.locale]['pool'], value: 'pool', length: this.tasksPool.length}]
      return this.isSchoolFeatureLocalePool ? filters : filters.filter(filter => filter.value !== 'pool')
    },
    filteredTasks () {
      switch (this.theFilter) {
        case 'person_resource':
          return this.tasksTeaching
        case 'additional_tasks':
          return this.tasksTasks
        case 'preparation':
          return this.tasksPrep
        case 'pool':
          return this.tasksPool
        default:
          return this.tasks
      }
    },
    sortedTasks () {
      return this.filteredTasks.sort((a, b) => a.name.localeCompare(b.name))
    },
    searchedTasks () {
      return this.sortedTasks.filter(task => {
        task.user_calendar_ids = task.user_calendar_ids.filter(calId => this.allCalendarsInHash[calId])
        return task.name !== null ? task.name.match(new RegExp(this.query, 'i')) : ''
      })
    },
    allCalendarsInHash () {
      return this.$store.getters.allCalendarsInHash
    },
    usersHash () {
      return this.$store.getters.allUsersInHash
    },
    calcAllHours () {
      let count = 0
      this.filteredTasks.forEach(task => {
        count += task.user_calendar_ids ? task.hours * task.user_calendar_ids.length : 0
      })
      return count
    },
    keyboardShortcut () {
      return this.isShowCreateFast ? 'esc' : 'N'
    },
    hasValidNumber () {
      let hasNumber = -1
      if (this.fastFormHoursTeaching !== '') {
        hasNumber = this.fastFormHoursTeaching * 1
      } else if (this.fastFormHoursTask !== '') {
        hasNumber = this.fastFormHoursTask * 1
      } else if (this.fastFormHoursPrep !== '') {
        hasNumber = this.fastFormHoursPrep * 1
      }
      return hasNumber > -1
    },
    isFastFormValid () {
      return this.fastFormName.length > 0 && this.hasValidNumber
    },
    theDeletedItemId () {
      return this.$store.state.subjects.theDeletedItemId
    }
  },
  watch: {
    theDeletedItemId () {
      this.closeUpdateTask()
    }
  },
  methods: {
    selectAllOnFocus (evt) {
      setTimeout(_ => {
        evt.target.select()
      }, 0)
    },
    setFilter (val) {
      this.theFilter = val
      this.fastFormHoursTeaching = ''
      this.fastFormHoursTask = ''
      this.fastFormHoursPrep = ''
    },
    closeDSelect () {
      if (!this.activeDSelect) {
        return
      }
      this.activeDSelect = null
    },
    isActiveDSelect (taskId) {
      return this.activeDSelect === taskId
    },
    setActiveDSelect (task) {
      if (task.user_calendar_ids.length < 1) {
        this.activeDSelectShow = true
      } else {
        this.activeDSelectShow = false
      }
      this.activeDSelect = task.id
    },
    getUsers (userCalIds) {
      return userCalIds.map(calId => this.allCalendarsInHash[calId] ? this.allCalendarsInHash[calId].name : '')
    },
    closeSearchGroup () {
      if (this.isSearchHidden) {
        return
      }
      this.isSearchHidden = true
      this.isSearchHiddenFadeIn = false
      this.query = ''
    },
    setIsSearchHidden (boolean) {
      if (!boolean) {
        this.isSearchHidden = false
        setTimeout(_ => {
          this.$refs.query_input.focus()
          this.isSearchHiddenFadeIn = true
        }, 0)
      }
    },
    setCreateNewTask () {
      this.editTask = null
      this.isTaskModal = true
    },
    submitFastForm () {
      this.fastFormValidation()
      if (Object.keys(this.formErrors).length > 0) {
        return
      }
      let subjectType = 'additional_tasks'
      let hours = 0
      if (this.fastFormHoursTeaching) {
        subjectType = 'person_resource'
        hours = this.fastFormHoursTeaching
      } else if (this.fastFormHoursTask) {
        subjectType = 'additional_tasks'
        hours = this.fastFormHoursTask
      } else if (this.fastFormHoursPrep) {
        subjectType = 'preparation'
        hours = this.fastFormHoursPrep
      }
      let newTask = {
        schoolYearId: this.activeSchoolYear.id,
        subjectType: subjectType,
        hours: hours,
        name: this.fastFormName,
        color: '#999999',
        defaultDuration: 45,
        preparation: null,
        belongsToCalendars: this.fastFormUsers.map(user => user.id),
        userCalendars: null,
        canSchedule: false,
        inUserCalendar: true
      }
      this.$store.dispatch('createTask', newTask)
      this.resetFastForm()
      this.isShowCreateFast = false
      setTimeout(_ => {
        this.isShowCreateFast = true
      }, 200)
      setTimeout(_ => {
        this.$refs.shortcutInput.focus()
      }, 500)
    },
    resetFastForm () {
      this.fastFormName = ''
      this.fastFormHoursTeaching = ''
      this.fastFormHoursTask = ''
      this.fastFormHoursPrep = ''
      this.fastFormUsers = []
    },
    createTask (task) {
      task['schoolYearId'] = this.activeSchoolYear.id
      this.$store.dispatch('createTask', task)
      this.isTaskModal = false
      setTimeout(_ => {
        this.isTaskModal = true
      }, 0)
    },
    setEditTask (task) {
      this.isTaskModal = false
      this.editTask = task
      setTimeout(_ => {
        this.isTaskModal = true
      }, 0)
    },
    closeUpdateTask () {
      this.isTaskModal = false
      this.editTask = null
    },
    updateTask (updatesForTask) {
      this.$store.dispatch('updateTask', updatesForTask)
      this.closeUpdateTask()
    },
    getCalcTotal (task) {
      return task.hours * task.user_calendar_ids.length
    },
    setSelectedUsers (users, task) {
      if (!task) {
        this.fastFormUsers = users
        return
      }
      const userCalIdsCannotDelete = this.usersWithEvents(task) || [] // Sikrer, at der ikke bliver slettet brugere der ikke kan (også dem der har forladt skolen)
      const userCalendars = Array.from(new Set(users.map(user => user.id).concat(userCalIdsCannotDelete)))
      let belongsToCalendars = []
      if (!task.in_user_calendar) {
        belongsToCalendars = task.belongs_to_calendars[0]
      } else {
        belongsToCalendars = userCalendars // Fordi userCalendars allerede inkluderer både users og userCalIdsNotOnSchool
      }

      let updatedTask = {
        schoolId: task.school_id,
        schoolYearId: task.school_year_id,
        id: task.id,
        name: task.name,
        color: task.color,
        hours: task.hours,
        defaultDuration: task.default_duration,
        preparation: Number(task.preparation) || 0,
        belongsToCalendars: belongsToCalendars,
        userCalendars: userCalendars,
        inUserCalendar: task.in_user_calendar
      }
      this.updateTask(updatedTask)
    },
    setIsShowCreateFast () {
      if (!this.isShowCreateFast) {
        this.openIsShowCreateFast()
      } else {
        this.closeIsShowCreateFast()
      }
    },
    openIsShowCreateFast () {
      this.isShowCreateFast = true
      setTimeout(_ => {
        this.$refs.shortcutInput.focus()
      }, 500)
    },
    closeIsShowCreateFast () {
      this.isShowCreateFast = false
      this.resetFastForm()
    },
    fastFormValidation () {
      if (this.fastFormName.length < 1) {
        this.$set(this.formErrors, 'fastFormName', {
          da: 'Opgaven skal have et navn',
          en: 'Task must have a name',
          nb: 'Opgave må ha et navn'
        })
      }
      if (!this.hasValidNumber) {
        this.$set(this.formErrors, 'fastFormHours', {
          da: 'Opgaven skal tildeles en pulje',
          en: 'The task must be assigned a number of hours',
          nb: 'Oppgaven skal tildeles et antall timer'
        })
      }
    },
    removeErrors (title) {
      this.$delete(this.formErrors, title)
    },
    usersWithEvents (task) {
      let usersWithEvents = []
      task.subjects.forEach(subject => {
        if (subject.has_events) {
          if (subject.user_calendars.length > 0) {
            // Is in other calendar
            usersWithEvents = subject.user_calendars
          } else {
            // Is in own calendar
            usersWithEvents.push(subject.calendar_id)
          }
        }
      })
      return usersWithEvents
    },
    getUserNames (calIds) {
      return calIds.map(calId => this.allCalendarsInHash[calId] ? this.allCalendarsInHash[calId].name : '')
    }
  },
  mounted () {
    this._keyListener = function (e) {
      // if (e.key === 'n' && (e.ctrlKey || e.metaKey)) {
      if (e.key === 'n') {
        if ((e.target.tagName.toUpperCase() === 'BODY')) {
          this.setIsShowCreateFast()
        }
      }
      if (e.key === 'Escape') {
        this.closeIsShowCreateFast()
      }
    }
    document.addEventListener('keydown', this._keyListener.bind(this))
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this._keyListener)
  }
}
</script>


<style scoped>
@import '../../assets/css/variables.css';

.tasks-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--border-color);
  margin-bottom: 0.5rem;
}

.tasks-header__right {
  display: flex;
  align-items: center;
  gap: 1rem
}

.d-table {
  width: 100%;
  border-spacing: initial;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  position: relative;
}

.d-table thead tr th:first-child {
  border-radius: 4px 0 0 0;
  max-width: 200px;
  padding-left: 16px;
}

.d-table thead tr th:last-child {
  border-radius: 0 4px 0 0;
  padding-right: 16px;
}

.d-table tr th {
  padding: 8px;
  border-bottom: 1px solid #e2e8f0;
}

.d-table thead {
  background: #f6f9fc;
  text-transform: uppercase;
  padding: 8px;
  font-weight: normal;
  border-collapse: collapse;
  text-align: left;
  border: 1px solid #e2e8f0;
  color: #8898aa;
}

.d-table tbody tr {
  background: #ffffff;
}

.d-table tr td {
  border-bottom: 1px solid rgba(226, 232, 240, 0.4);
  padding: 8px;
}

.d-table tbody tr td:first-child {
  font-weight: bold;
  padding-left: 4px;
}

.d-table tbody tr td:last-child {
  padding-right: 16px;
}

.d-table__number {
  text-align: right;
}

.explainer-div {
  width: 100%;
  background-color: #ffffff;
  padding: 20px;
  font-style: italic;
}

.task__name {
  display: flex;
  align-items: center;
  padding-left: 0.5rem;
}

.task__name .td-subject--hidden {
  background: transparent !important;
}

.d-search__hidden__group {
  height: 34px;
  line-height: 34px;
  position: relative;
  padding-left: 16px;
  font-weight: normal;
  text-transform: initial;
  cursor: pointer;
}

.d-search__hidden__group > span {
  position: absolute;
  top: 11px;
  left: 0;
}

.d-search__hidden__group--hide {
  padding: 0 0 0 9px;
  width: 120px;
  border: 1px solid transparent;
  display: inline-block;
  margin-top: -1px;
  border-radius: 4px;
  transition: background-color 0.25s, border 0.25s;
}

.d-search__hidden__group--hide:hover {
  background-color: #ffffff;
  border-color: #e2e8f0;
}

.d-search__hidden__group--show > input[type="search"] {
  border: 1px solid #acb6be;
  font-weight: normal;
  width: 120px;
  transition: width 0.25s;
}

.d-search__hidden__group--show > input[type="search"]:focus,
.d-search__hidden__group--show > input[type="search"]:active {
  border: 1px solid var(--blue);
}

.d-search__hidden__group.isShow .d-search__hidden__group--show > input[type="search"] {
  width: 180px;
}

.scaleIn-enter-active {
  transition: all .3s ease;
}

.scaleIn-enter, .scaleIn-leave-to {
  transform: scale(0.96);
  opacity: 0;
}

.d-select-lookalike {
  height: 42px;
  position: relative;
}

.d-select-lookalike:after {
  content: attr(aria-placeholder-label);
  border-radius: 4px;
  display: flex;
  flex-wrap: wrap;
  transition: width 0.25s;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 9px;
  background: #ffffff;
  cursor: text;
  border: 1px solid #acb6be;
}

.task__users {
  min-height: 22px;
  width: 100%;
  border-radius: 4px;
  padding: 4px;
  cursor: pointer;
  border: 1px solid transparent;
  transition: border 0.1s;
}

.task__users:hover {
  border: 1px solid #acb6be;
}

.task__users > p {
  display: inline-block;
}

.task__users > p:after {
  content: ',';
  margin-right: 5px;
}

.task__users > p:last-child:after {
  content: '';
}

.td-subject {
  position: relative;
  padding: 4px 6px;
  height: 30px;
  color: #ffffff !important;
  border-radius: 4px;
  word-break: break-all;
  background: #2c81ba;
  overflow: hidden;
  box-shadow: 1px 1px 5px rgb(0 0 0 / 30%);
  text-align: left;
  min-width: auto;
  font-weight: bold;
  transition: transform 0.25s;
  animation: fadeIn;
  cursor: pointer;
  width: 220px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.td-subject--hidden {
  width: 220px;
  border: 1px solid transparent;
  padding: 4px 6px;
  border-radius: 4px;
  height: 30px;
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  position: relative;
}

.td-subject--hidden:hover {
  border-color: var(--border-color);
}

.td-subject--hidden:hover:before {
  content: "\e90e";
  font-family: 'icomoon' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  position: absolute;
  top: 8px;
  right: 4px;
  opacity: 0.7;
}

.d-table tbody {
  position: relative;
}

.tr-create-shortcut {
  position: absolute;
  z-index: 2;
  top: 37px;
  left: -12px;
  background-color: transparent;
  background-color: var(--grey);
  border-radius: 50%;
  color: #fff;
  height: 24px;
  width: 24px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 2px rgb(0 0 0 / 10%);
  cursor: pointer;
  transition: background-color 0.25s;
}

.tr-create-shortcut > span {
  transform: rotate(-45deg);
  transition: transform 0.25s;
}

tr.create-task-fast > * {
  user-select: none;
}

tr.create-task-fast input[type="text"],
tr.create-task-fast input {
  background-color: #ffffff;
  font-weight: normal;
}

.tr-create-shortcut.tr-create-shortcut--active > span {
  transform: rotate(0deg);
}

.d-table tbody tr.create-task-fast {
  background-color: var(--bg-grey);
}

.d-table tbody tr.create-task-fast td:first-child {
  padding-left: 1rem;
}

.d-table tbody tr.create-task-fast td {
  position: relative;
}

.d-table tbody tr.create-task-fast td input.input-error {
  border: 1px solid var(--danger);
}

input[type="number"]:disabled {
  cursor: not-allowed;
}

.dselect-input--error {
  border: 1px solid var(--danger);
}

</style>



// WEBPACK FOOTER //
// SubjectsDistributionTasks.vue?deffced4